<template>
  <svg fill="none" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
    <path
      clip-rule="evenodd"
      d="m65.215 61.725 5.255 24.38a11.24 11.24 0 0 0 10.044 8.83l25.579 2.17 2.455 9.079a5.61 5.61 0 0 1-.843 4.717l-25.917 36.486a5.62 5.62 0 0 1-6.29 2.103l-40.29-12.8a5.62 5.62 0 0 1-3.375-2.942l-17.818-37.45a5.615 5.615 0 0 1 1.342-6.612l33.084-29.384z"
      fill="#70E884"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M125.479 37.689a5.624 5.624 0 0 0-5.542-3.919l-31.693 1.02L72.67 56.755l21.15 1.794c4.712.4 8.672 3.703 9.905 8.266l6.326 23.389 23.325-12.354a5.616 5.616 0 0 0 2.727-6.662z"
      fill="#FF3167"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="M34.044 4.133A5.624 5.624 0 0 1 40.069.35l33.144 4.128A5.62 5.62 0 0 1 77.97 8.68l5.744 22.779-17.543 24.74-17.686-1.53L26.508 38.97a5.615 5.615 0 0 1-2.059-6.364z"
      fill="#0467F1"
      fill-rule="evenodd"
    />
    <path
      clip-rule="evenodd"
      d="m75.968 84.922-4.886-22.664 22.261 1.888a5.62 5.62 0 0 1 4.953 4.133l6.235 23.055-23.541-1.997a5.62 5.62 0 0 1-5.022-4.415"
      fill="#FFE504"
      fill-rule="evenodd"
    />
  </svg>
</template>
